import {
  GET_REPORT_DATA, GENERATE_REPORT_DATA, SAVE_REPORT_DATA, RESET_REPORT_FILE, RESET_REPORT_DATA,
} from '../../constants/system/actions';

const getReportData: Function = (payload?: ActionPayload, resolve?: Function, reject?: Function): ReduxAction => ({
  type: GET_REPORT_DATA, payload, resolve, reject,
});

const generateReportData: Function = (payload?: ActionPayload, resolve?: Function, reject?: Function): ReduxAction => ({
  type: GENERATE_REPORT_DATA, payload, resolve, reject,
});

const saveReportData: Function = (payload?: ActionPayload, resolve?: Function, reject?: Function): ReduxAction => ({
  type: SAVE_REPORT_DATA, payload, resolve, reject,
});

const resetReportFile: Function = (payload?: ActionPayload): ReduxAction => ({
  type: RESET_REPORT_FILE, payload,
});

const resetReportData: Function = (payload?: ActionPayload): ReduxAction => ({
  type: RESET_REPORT_DATA, payload,
});

export {
  getReportData,
  generateReportData,
  saveReportData,
  resetReportFile,
  resetReportData,
};
